import React, { createContext } from 'react';

import { Branch } from '@nw/shared/config';

interface BranchesContextTypes {
  branches: React.MutableRefObject<Array<Branch>>;
  selectedBranch: React.MutableRefObject<Branch>;
  updateBranches: (states: Array<Branch>) => void;
  updateSelectedBranch: (state: Branch) => void;
}

const BranchesContext = createContext<BranchesContextTypes | null>({
  branches: { current: [] },
  selectedBranch: { current: {} as Branch },
  updateBranches: () => {},
  updateSelectedBranch: () => {}
});

export const useBranches = () => {
  const context = React.useContext(BranchesContext);

  if (!context) throw new Error('Expected to be wrapped in a BranchesProvider');

  return context;
};

export const BranchesProvider = ({
  children
}: {
  children: React.ReactChild;
}) => {
  const branches = React.useRef<Array<Branch>>([]);
  const branch = React.useRef<Branch>({} as Branch);

  const updateBranches = (latestBranches: Array<Branch>) => {
    branches.current = latestBranches;
  };

  const updateSelectedBranch = (selectedState: Branch) => {
    branch.current = selectedState;
  };

  return (
    <BranchesContext.Provider
      value={{
        branches,
        selectedBranch: branch,
        updateBranches,
        updateSelectedBranch
      }}
    >
      {children}
    </BranchesContext.Provider>
  );
};
